import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    getDocs(collection(db, 'events')).then(snapshot => {
      const weekly = snapshot.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(e => e.active && e.type === 'weekly')
        .sort((a, b) => (a.order || 0) - (b.order || 0));
      setServices(weekly);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <h2 className="page-title">🕐 Horarios de Servicios</h2>

      {/* Schedule from Firebase */}
      <div className="card">
        <h3 style={{ marginBottom: 14 }}>📅 Horarios Semanales</h3>
        {loading && <p style={{ color: '#888', textAlign: 'center', padding: '16px 0' }}>Cargando...</p>}
        {!loading && (
          <table className="times-table">
            <thead>
              <tr><th>Día</th><th>Servicio</th><th>Hora</th></tr>
            </thead>
            <tbody>
              {services.map(s => (
                <tr key={s.id}>
                  <td>{s.day}</td>
                  <td>{s.title}</td>
                  <td>{s.time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Address */}
      <div className="card">
        <h3>📍 Dirección</h3>
        <p>4700 N Beach St<br />Fort Worth, TX</p>
        <a
          href="https://maps.apple.com/?q=4700+N+Beach+St+Fort+Worth+TX"
          target="_blank"
          rel="noreferrer"
          className="btn"
          style={{ marginTop: 14, display: 'inline-flex' }}
        >
          🗺 Ver en Mapas
        </a>
      </div>

      {/* Contact */}
      <div className="card">
        <h3>📞 Contáctanos</h3>
        <p>Teléfono: <a href="tel:8179957398">(817) 995-7398</a></p>
        <p style={{ marginTop: 8 }}>Sitio Web: <a href="https://bethesdacommunitychurch.com/home-2/" target="_blank" rel="noreferrer">bethesdacommunitychurch.com</a></p>
      </div>
    </>
  );
}
